import { Segmented } from '@/components';
import { t } from '@/i18n';
import { type FC, useMemo } from 'react';
import { useNavigate } from 'react-router';
import { z } from 'zod';
import type { AnalysisSheetType } from '../_hooks/useAnalysisSheetType';

const analysisSegment = z.enum(['review-sheet', 'fund-sheet']);
type AnalysisSegment = z.infer<typeof analysisSegment>;

export const sheetTypeToSegment = {
  RS: 'review-sheet',
  KS: 'fund-sheet',
} as const satisfies Record<AnalysisSheetType, AnalysisSegment>;

const analysisSegmentLabelModifier = {
  'review-sheet': t('review-sheet'),
  'fund-sheet': t('fund-sheet'),
} as const satisfies Record<AnalysisSegment, string>;

type Props = {
  segment: AnalysisSegment;
};

export const AnalysisSegmentSwitcher: FC<Props> = ({ segment }) => {
  const navigate = useNavigate();

  const options = useMemo(
    () =>
      analysisSegment.options.map((value) => ({
        label: analysisSegmentLabelModifier[value],
        value,
      })),
    [],
  );

  return (
    <div>
      <Segmented
        value={segment}
        onChange={(value) => {
          navigate(`/analysis/${value}`, { replace: true });
        }}
        options={options}
      />
    </div>
  );
};
